// Service for handling password reset for the logged-in user
import axios from './axios';
import { getToken } from './authService';

export async function resetPassword({ oldPassword, newPassword }) {
  const token = getToken();
  if (!token) throw new Error('No token');
  const res = await axios.post('/api/auth/reset-password', {
    oldPassword,
    newPassword
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}
